<template>
  <div class="page-content prose">
    <div class="container">
      <h1>Informatie over Notarissen</h1>

      <p>
        Via Notarissenvergelijker.nl vraagt u niet alleen aktes aan. U vindt
        hier ook informatie over hoe notarissen werken en waarvoor u de notaris
        kunt inschakelen. Notarissen zijn onpartijdige deskundigen die de
        belangen behartigen van u en alle partijen die betrokken zijn bij het
        opstellen van een notariële akte waar dit verplicht is. U bent zo
        verzekerd van een juiste akte die altijd als bewijs kan dienen.
        Notarissen zijn verplicht aktes te allen tijde te bewaren.
      </p>

      <h2>Aktes</h2>
      <p>
        Notarissenvergelijker stelt u de door u gewenste aktes aan te vragen.
        Aktes zijn officiele, bij wet bekrachtigde documenten waarin afspraken
        en rechtshandelingen worden vastgelegd.
      </p>
      <p>
        Naast de authentieke akte welke te allen tijde door een notaris wordt
        opgesteld is het ook mogelijk afspraken die door u zelf opgesteld zijn
        door een notaris te laten bekrachtigen. Dit noemt men de zogenaamde
        onderhandse akte.
      </p>

      <h2>Voorbeelden van aktes waarvoor u een notaris inschakelt:</h2>
      <p>De wet verplicht het opstellen van een akte door een notaris bij:</p>

      <ul class="mb-4">
        <li>Het maken en wijzigen van testamenten</li>
        <li>
          Overdracht van registergoederen. Denk hierbij aan bijvoorbeeld
          woningen
        </li>
        <li>Vestigen of teniet doen van het recht van hypotheek</li>
        <li>Het oprichten van een BV, NV, stichting of vereniging</li>
        <li>
          Het maken en wijzigen van huwelijkse voorwaarden en/of
          partnerovereenkomsten
        </li>
        <li>
          Verdelen van erfenissen waarbij notariële vastlegging benodigd is
        </li>
        <li>
          Het doen van- of ontvangen van schenkingen waarbij notariële
          vastlegging benodigd is
        </li>
        <li>Verdeling van gebouwen in appartementen</li>
        <li>
          Huurkoopovereenkomsten die betrekking hebben op registergoederen
        </li>
      </ul>

      <p>
        Ook voor een samenlevings contract kunt u bij de notaris terecht. Hoewel
        dit niet verplicht is geeft het u wel de zekerheid dat alles wettelijk
        is vastgelegd en bekrachtigd.
      </p>

      <h2>Aktes hebben betrekking op de volgende rechtsgebieden:</h2>
      <ul class="mb-4">
        <li>Personen- en familierecht</li>
        <li>Onroerende zaakrecht</li>
        <li>Rechtspersonenrecht</li>
      </ul>

      <h2>Personen- en familierecht</h2>
      <p>
        Dit onderdeel heeft betrekking op familiebetrekkingen en bevoegdheden
        van personen. Het gaat hierbij onder andere om geboorte, afstamming,
        huwelijk en echtscheiding. Notariële akte die horen tot het personen- en
        familierecht zijn onder andere:
      </p>

      <h2>Huwelijkse voorwaarden</h2>
      <p>
        Gaat u trouwen? Wanneer u het huwelijksbootje instapt zonder dat er
        huwelijkse voorwaarden opgesteld zijn, trouwt u automatisch in
        gemeenschap van goederen. In dit geval worden de bezittingen en het
        vermogen van de partners als één bezitting en één vermogen beschouwd.
        Wanneer u dit niet wenst, is het mogelijk dit vast te leggen in een
        overeenkomst van huwelijkse voorwaarden. Deze wordt door een notaris
        opgesteld.
      </p>

      <h2>Testament</h2>
      <p>
        Wanneer u geen testament heeft opgesteld en komt te overlijden, bepaald
        de wet welke personen recht hebben op uw vermogen. Door het opstellen
        van een testament kunt u zelf bepalen wat er met uw vermogen gebeurt en
        wie uw erfgenamen zijn. Zo bestaat de mogelijkheid om personen uit te
        sluiten als erfgenaam. Ook bestaat de mogelijkheid om enkele voorwaarde
        op te leggen aan de erfgenamen. Een notaris bespreekt met u uw situatie
        en uw wensen. Nadat de notaris het testament opgesteld heeft, dient u
        deze nogmaals te beoordelen. Wanneer u het eens bent met het testament
        dient u een tweede keer naar het notariskantoor te komen. Hier wordt uw
        testament nogmaals met u doorgesproken. Wanneer alles duidelijk is en u
        het volledig eens bent met de inhoud mag de akte ondertekend worden.
        Hierna is uw testament rechtsgeldig. Overigens kan u uw testament te
        allen tijde wijzigen. Hierbij wordt een nieuwe akte opgesteld, ook dit
        dient een notaris te doen.
      </p>

      <h2>Echtscheidingsakten</h2>
      <p>
        In een echtscheidingsakte worden de huwelijkse voorwaarden ontbonden.
        Dit heeft als gevolg dat de twee partners niet meer met elkaar getrouwd
        zijn. In deze akte wordt beschreven hoe alle bezittingen en vermogens
        verdeeld worden tussen beide. Hierin wordt overeengekomen wat er moet
        gebeuren met de gezamenlijke woning. Wanneer u kinderen heeft worden
        regels vastgesteld betreffende de alimentatie. Ook kan er een
        ouderschapsplan opgesteld worden.
      </p>

      <h2>Onroerendezaakrecht</h2>
      <p>
        Een onroerende zaak heeft betrekking op de grond en de gebouwen op deze
        grond. Dit wordt ook wel vastgoed of onroerend goed genoemd. Het gaat
        hierbij om niet-verplaatsbare goederen. Notariële akten die behoren tot
        het onroerendezaakrecht zijn onder andere:
      </p>

      <h2>Onroerendezaakrecht</h2>
      <p>
        Een onroerende zaak heeft betrekking op de grond en de gebouwen op deze
        grond. Dit wordt ook wel vastgoed of onroerend goed genoemd. Het gaat
        hierbij om niet-verplaatsbare goederen. Notariële akten die behoren tot
        het onroerendezaakrecht zijn onder andere:
      </p>

      <h2>Hypotheekakten</h2>
      <p>
        Gaat u een onroerende zaak kopen, bijvoorbeeld een huis? Dan heeft u een
        hypotheekakte nodig. Dit betreft een overeenkomst tussen de
        hypotheekverlener en de hypotheekhouder. De hypotheekverlener is de
        eigenaar van de onroerende zaak. De hypotheekhouder is in de meeste
        gevallen de bank, maar het kan ook de verzekeringsmaatschappij of een
        pensioenfonds zijn. Wanneer u een huis gaat kopen, zal u geld moeten
        lenen voor deze aankoop. In dit geval verleent u hypotheek. De
        hypotheekhouder leent het geld aan u uit. Als tegenprestatie krijgt de
        hypotheekhouder de onroerende zaak als onderpand.
      </p>
      <p>
        De hypotheekakte wordt door een notaris opgesteld. In deze akte staat
        onder andere een uitgebreide vermelding van de onroerende zaak waar de
        hypotheek voor bestemd is. Ook de hypotheeksom is terug te vinden in
        deze akte evenals de manier van aflossing en gegevens over de
        hypotheekrente. Hiernaast wordt ook vastgesteld wat de regels zijn
        omtrent het tussentijds ontbinden van de looptijd.
      </p>

      <h2>Akte van levering</h2>
      <p>
        Deze akte regelt de overdacht van een onroerende zaak, zoals een huis.
        Het is zowel een bewijs van betaling als van eigendom. De notaris stelt
        de akte op. Zowel de koper als de verkoper dienen deze te ondertekenen.
        Na deze ondertekening bent u officieel de eigenaar van de onroerende
        zaak.
      </p>

      <h2>Rechtspersonenrecht</h2>
      <p>
        Een rechtspersoon is een juridische vorm waardoor het mogelijk is dat
        een organisatie op kan treden als een natuurlijk persoon. Zo kan een
        rechtspersoon bezittingen en schulden hebben, een rechtszaak aanspannen,
        aangeklaagd worden en contracten sluiten. Notariële akten die voor het
        rechtspersonenrecht opgesteld kunnen worden zijn onder andere:
      </p>

      <h2>Oprichtingsakte</h2>
      <p>
        Bent u van plan om een naamloze vennootschap, besloten vennootschap of
        een stichting op te richten? In dat geval dient u een oprichtingsakte
        door de notaris op te laten stellen. Hierin worden de grondregels van de
        NV, BV of stichting vastgelegd. Hierbij gaat het onder andere om het
        aandelenkapitaal, de naam en het doel van de rechtspersoon en de
        blokkeringsregeling. De blokkeringsregeling is alleen op een BV van
        toepassing. Voordat een vennootschap bij de kamer van koophandel
        ingeschreven wordt bekijkt de notaris of er aan alle wettelijke eisen
        voldaan is.
      </p>

      <h2>Statutenwijzigingen</h2>
      <p>
        Statuten zijn de belangrijkste regels die een onderneming zichzelf
        oplegt. Hierbij kan het gaan om de wijze van benoeming van de
        bestuurders, de overdracht van aandelen, maatschappelijk kapitaal enz.
        De statuten moeten in het handelsregister worden ingeschreven. De
        notaris zal deze akte opstellen.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Notaris offertes gratis vergelijken',
      headDescription:
        'De goedkoopste Notarissen vindt je via Notarissenvergelijker.nl. Direct 6 offertes in jouw e-mail box van specialisten. 100% gratis. Bespaar tot wel 40% op kosten!',
      path: '/informatie-over-notarissen',
    }
  },
}
</script>
